import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface EditorLoadingPaneProps {
  title: string;
  description: string;
}

export function EditorLoadingPane({ title, description }: EditorLoadingPaneProps) {
  return (
    <Card className="min-h-[620px]">
      <CardHeader className="border-b">
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>

      <CardContent className="flex min-h-[520px] items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-primary" />
      </CardContent>
    </Card>
  );
}
